export default __webpack_public_path__ + "static/media/Responsive_Quality_partnerships.794b26b7.webp";